import * as React from "react";
import apiClients, { MultiCloudDatabaseApiVersion } from "../../apiClients";
import { InfoPanelId } from "../../constants/pluginConstants";
import { ttlOneMinCaching } from "../../constants/uiConstants";
import { parseId } from "../../helpers/idHelper";
import { optimizedRetryOption } from "../../helpers/resourceHelper";
import { AnalyticsDataPage, LinkAnalyticsData } from "../../hooks/useAnalytics";
import { useQueryCall } from "../../hooks/useQueryCall";
import { getOciRegion } from "../../utils";
import { Resource, ResourceLink } from "./ResourceLink";

export interface VmDbHomeLinkProps {
  dbHomeId: string|undefined;
  location: string;
  onClick: () => void;
  analytics: AnalyticsDataPage;
}

export const VmDbHomeLink = ({
  dbHomeId,
  location,
  onClick,
  analytics,
}: VmDbHomeLinkProps): JSX.Element => {
  const { subscriptionId, resourceGroup, resourceName } = parseId(dbHomeId);
  const { response, error, loading } = useQueryCall({
    wait: !dbHomeId,
    method: apiClients.withRegion(getOciRegion(location)).vmDatabaseApi.getVmdbDbHome,
    options: {
      args: {
        subscriptionId,
        resourceGroupName: resourceGroup,
        apiVersion: MultiCloudDatabaseApiVersion,
        dbHomeName: resourceName,
      },
      caching: ttlOneMinCaching,
      retry: optimizedRetryOption,
    },
  });
  const dbHome = response?.data;

  return (
    <ResourceLink
      resource={dbHome as Resource}
      navigation={{ onClick }}
      analytics={{
        target: InfoPanelId.DBHOME,
        source: { pageId: analytics.pageId, panelId: analytics.panelId },
      } as LinkAnalyticsData}
      error={error}
      loading={loading}
    />
  );
};
